export default "__VITE_ASSET__CQDMpw_e__"